import React, { useState, useEffect } from 'react';
import {Home,Settings,LogOut, Mail,Users,Menu,Wrench,Book,Tag} from 'lucide-react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_URL;

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [activeMenu, setActiveMenu] = useState(
    location.pathname.replace('/', '') || 'dashboard'
  );
  const [userMenuOpen, setUserMenuOpen] = useState(false);  // State for user submenu
  const [emailMenuOpen, setEmailMenuOpen] = useState(false);  // State for email submenu
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);  // State for settings submenu
  const [reportMenuOpen, setReportMenuOpen] = useState(false);  // State for Report submenu

  useEffect(() => {
    const adminStatus = sessionStorage.getItem('isAdmin') === 'true';
    setIsAdmin(adminStatus);
  }, []);

  const handleHangfire = () => {
    window.open(`${apiUrl}/Hangfire`, '_blank');
  };

  const handleLogout = () => {
    sessionStorage.removeItem('BUId');
    sessionStorage.removeItem('isLoggedIn');
    sessionStorage.removeItem('IsAdmin');
    navigate('/login');
  };

  const menuItems = [
    {// common
      icon: <Home className="w-5 h-5" />,
      label: 'Dashboard',
      key: 'dashboard',
      route: '/dashboard',
      showAlways: true
    },
    {// User
      icon: <Users className="w-5 h-5" />,
      label: 'User Profile',
      key: 'UserProfile',
      route: '/UserProfile',
      showAlways: !isAdmin
    },

    //{// 
    // icon: <Users className="w-5 h-5" />,
    // label: 'User Management',
    // key: 'UserList',
    // route: '/UserList',
    // showAlways: isAdmin

    {// Admin
      icon: <Tag className="w-5 h-5" />,
      label: 'Create Tag',
      key: 'tags',
      route: '/TagList',
      showAlways: isAdmin
    },

    {
      icon: <Users className="w-5 h-5" />,
      label: 'User Management',
      key: 'user',
      showAlways: isAdmin,
      onClick: () => setUserMenuOpen(!userMenuOpen),  // Toggle email submenu
      submenu: [
        {
          label: 'Create User',
          route: '/UserList',
          key: 'UserList',
        },
        {
          label: 'Create User Mails',
          route: '/UserMailList',
          key: 'UserMailList',
        },


      ],
    },

    {
      icon: <Mail className="w-5 h-5" />,
      label: 'Email',
      key: 'email',
      showAlways: true,
      onClick: () => setEmailMenuOpen(!emailMenuOpen),  // Toggle email submenu
      submenu: [
        {
          label: 'Mail Details',
          route: '/ScheduledMailDetails',
          key: 'ScheduledMailDetails',
        },
        {
          label: 'Campaign',
          route: '/CampaignList',
          key: 'CampaignList',
        },
        {
          label: 'Mail Template',
          route: '/TemplateList',
          key: 'TemplateList',
        },
        {
          label: 'Import Contacts',
          route: '/CreateContacts',
          key: 'CreateContacts',
        },
        {
          label: 'Schedule Mail',
          route: '/SendBulkMail',
          key: 'SendBulkMail',
        },
        {
          label: 'Update Bounce Mail',
          route: '/BounceMailUpdate',
          key: 'BounceMailUpdate',
        },
      ],
    },
    {
      icon: <Book className="w-5 h-5" />,
      label: 'Reports',
      key: 'reports',
      showAlways: true,
      onClick: () => setReportMenuOpen(!reportMenuOpen),  // Toggle email submenu
      submenu: [
        {
          label: 'Mail Details',
          route: '/AllDetailsList',
          key: 'AllDetailsList',
        },
        {
          label: 'UnSubscribe List',
          route: '/UnSubsribedList',
          key: 'CampaignList',
        },
        {
          label: 'Bounce List Report',
          route: '/BounceListReport',
          key: 'BounceList',
        },
      ]
    },

    // {
    //   icon: <Wrench className="w-5 h-5" />,
    //   label: 'Hangfire',
    //   key: 'Hangfire',
    //   onClick: handleHangfire,
    //   showAlways: isAdmin
    // },
    {
      icon: <Settings className="w-5 h-5" />,
      label: 'Settings',
      key: 'Settings',
      showAlways: true,
      onClick: () => setSettingsMenuOpen(!settingsMenuOpen),  // Toggle settings submenu
      submenu: [
        {
          label: 'Change Password',
          route: '/ChangePassword',
          key: 'ChangePassword',
        },
      ],
    },
  ];

  const filteredMenuItems = menuItems.filter(item =>
    item.showAlways || (isAdmin && item.key !== 'UserProfile')
  );

  const handleMenuClick = (item) => {
    if (item.onClick) {
      item.onClick();
    } else if (item.route) {
      navigate(item.route);
      setActiveMenu(item.route.replace('/', ''));
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        className={`
          ${isSidebarOpen ? 'w-64' : 'w-20'} 
          bg-white shadow-md transition-all duration-300 ease-in-out
          fixed left-0 top-0 bottom-0 z-40 flex flex-col
        `}
      >
        <div className="flex items-center justify-between p-6 border-b">
          {isSidebarOpen && (
            <h1 className="text-2xl font-bold text-gray-800">Post Pilot</h1>
          )}
          <button
            onClick={toggleSidebar}
            className="ml-auto p-2 hover:bg-gray-100 rounded-lg"
          >
            <Menu className="w-6 h-6" />
          </button>
        </div>
        
        {/* Scrollable navigation area */}
        <nav className="p-4 overflow-y-auto flex-grow">
          <div className="space-y-2">
            {filteredMenuItems.map((item) => (
              <div key={item.key}>
                <button
                  onClick={() => handleMenuClick(item)}
                  className={`
                    w-full flex items-center space-x-3 p-3 rounded-lg
                    ${(location.pathname === item.route ||
                      (item.route === '/dashboard' && location.pathname.includes('dashboard')))
                      ? 'bg-blue-100 text-blue-600'
                      : 'hover:bg-gray-100 text-gray-700'}
                    ${!isSidebarOpen ? 'justify-center' : ''}
                  `}
                  title={!isSidebarOpen ? item.label : ''}
                >
                  {item.icon}
                  {isSidebarOpen && <span>{item.label}</span>}
                </button>

                {/* Submenu for User */}
                {item.submenu && userMenuOpen && item.key === 'user' && (
                  <div className="ml-4 mt-2 space-y-1">
                    {item.submenu.map(subItem => (
                      <button
                        key={subItem.key}
                        onClick={() => handleMenuClick(subItem)}
                        className={`w-full flex items-center space-x-3 p-2 rounded-lg
                          ${(location.pathname === subItem.route)
                            ? 'bg-blue-100 text-blue-600'
                            : 'hover:bg-gray-100 text-gray-700'}
                          ${!isSidebarOpen ? 'justify-center' : ''}
                        `}
                      >
                        {isSidebarOpen && <span>{subItem.label}</span>}
                      </button>
                    ))}
                  </div>
                )}
                
                {/* Submenu for Email */}
                {item.submenu && emailMenuOpen && item.key === 'email' && (
                  <div className="ml-4 mt-2 space-y-1">
                    {item.submenu.map(subItem => (
                      <button
                        key={subItem.key}
                        onClick={() => handleMenuClick(subItem)}
                        className={`w-full flex items-center space-x-3 p-2 rounded-lg
                          ${(location.pathname === subItem.route)
                            ? 'bg-blue-100 text-blue-600'
                            : 'hover:bg-gray-100 text-gray-700'}
                          ${!isSidebarOpen ? 'justify-center' : ''}
                        `}
                      >
                        {isSidebarOpen && <span>{subItem.label}</span>}
                      </button>
                    ))}
                  </div>
                )}

                {/* Submenu for Report */}
                {item.submenu && reportMenuOpen && item.key === 'reports' && (
                  <div className="ml-4 mt-2 space-y-1">
                    {item.submenu.map(subItem => (
                      <button
                        key={subItem.key}
                        onClick={() => handleMenuClick(subItem)}
                        className={`w-full flex items-center space-x-3 p-2 rounded-lg
                          ${(location.pathname === subItem.route)
                            ? 'bg-blue-100 text-blue-600'
                            : 'hover:bg-gray-100 text-gray-700'}
                          ${!isSidebarOpen ? 'justify-center' : ''}
                        `}
                      >
                        {isSidebarOpen && <span>{subItem.label}</span>}
                      </button>
                    ))}
                  </div>
                )}

                {/* Submenu for Settings */}
                {item.submenu && settingsMenuOpen && item.key === 'Settings' && (
                  <div className="ml-4 mt-2 space-y-1">
                    {item.submenu.map(subItem => (
                      <button
                        key={subItem.key}
                        onClick={() => handleMenuClick(subItem)}
                        className={`w-full flex items-center space-x-3 p-2 rounded-lg
                          ${(location.pathname === subItem.route)
                            ? 'bg-blue-100 text-blue-600'
                            : 'hover:bg-gray-100 text-gray-700'}
                          ${!isSidebarOpen ? 'justify-center' : ''}
                        `}
                      >
                        {isSidebarOpen && <span>{subItem.label}</span>}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </nav>
        
        {/* Logout button - fixed at bottom */}
        <div className="p-4 border-t">
          <button
            onClick={handleLogout}
            className={`
              w-full flex items-center space-x-3 p-3 rounded-lg
              hover:bg-red-100 text-red-600
              ${!isSidebarOpen ? 'justify-center' : ''}
            `}
            title={!isSidebarOpen ? 'Logout' : ''}
          >
            <LogOut className="w-5 h-5" />
            {isSidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </div>

      {/* Main Content Area */}
      <div
        className={`
          flex-1 p-10 transition-all duration-300 ease-in-out
          ${isSidebarOpen ? 'ml-64' : 'ml-20'}
        `}
      >
        <div className="bg-white rounded-lg shadow-md p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;